import { PureComponent, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import countries from 'i18n-iso-countries';

import {
  Button,
  Form,
  Grid,
  Icon,
  Image,
  Modal,
  Segment,
} from 'semantic-ui-react';

import { isEmpty, isEqual, map } from '../../../utils/lodash';

import {
  getProvincesAndStates,
  getIndustrySectorTypes,
  getOrganization,
  updateOrganizationInfo,
  updateOrganizationLogo,
} from '../../../store/actions';

import {
  CustomInput,
  CustomCheckbox,
  CustomDropdown,
} from '../../../components/form';

// import orgLogo from '../../../assets/org-logo.svg';
// import NavigationPrompt from 'react-router-navigation-prompt';

import {
  getOrgProfileInitialValues,
  profileValidationSchema,
  profileValidationSchemaWithDifferentPostalAddress,
} from '../../../validations/orgProfileValidation';

import './organization.scss';

class OrganizationProfile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      organization: [],
      orgForm: {},
      modalShow: false,
      file: null,
      imgPreView: null,
    };
    this.fileInput = createRef();
    this.fileInputRef = createRef();
    this.diffAddress = this.diffAddress.bind(this);
  }

  async componentDidMount() {
    const {
      auth,
      getOrganization,
      getProvincesAndStates,
      getIndustrySectorTypes,
    } = this.props;

    if (!isEmpty(auth.user) && auth.user.organisation) {
      await getOrganization(auth.user.organisation.id);
    }

    await Promise.all([getProvincesAndStates(), getIndustrySectorTypes()]);

    const {
      organization,
      auth: { user },
    } = this.props;
    this.setState({
      organization: organization.organization,
      orgForm: organization.organization,
    });

    const file =
      user.organisation && user.organisation.logo
        ? user.organisation.logo.documentUrl
        : null;

    this.setState({
      imgPreView: file ? file : null,
    });

    if (
      organization.organization &&
      (organization.organization.postalStreetAddress ||
        organization.organization.postalCitySuburb ||
        organization.organization.postalStateId ||
        organization.organization.postalPostcode)
    ) {
      this.setState({ isChecked: true });
    }
  }

  diffAddress() {
    this.setState((prevState) => ({
      isChecked: !prevState.isChecked,
    }));
  }

  async onSubmit(values) {
    const { t } = this.props;

    try {
      const file = this.state.file;
      delete values.diffPostalAddress;

      if (!this.state.isChecked) {
        values.postalPostcode =
          values.postalPostcode !== null
            ? values.postalPostcode.toString()
            : null;

        values.postalStreetAddress = null;
        values.postalStreetAddress2 = null;
        values.postalCitySuburb = null;
        values.postalStateId = null;
        values.postalPostcode = null;
      }

      if (file) {
        await this.props.updateOrganizationLogo(file);
      }
      await this.props.updateOrganizationInfo(values);
      this.form && this.form.reset();
      this.setState({
        modalShow: false,
      });
      this.props.isEditToggle(false);
    } catch (error) {
      console.error('error from updating organization: ', error);
      NotificationManager.error(t('error_messages.something_went_wrong'));
    }
  }

  onChange(type, value) {
    if (type === 'logo' && !!value.target.files[0]) {
      this.setState({
        file: value.target.files[0],
        imgPreView: value.target.files[0]
          ? window.URL.createObjectURL(value.target.files[0])
          : null,
      });
    }

    this.setState(
      (prevState) => ({
        orgForm: {
          ...prevState.orgForm,
          [type]: isNaN(value) ? value : Number(value),
        },
      }),
      () => {
        this.isSaved();
      }
    );
  }

  async isSaved() {
    const { organization } = this.props.organization;
    const { orgForm } = this.state;

    if (!isEmpty(orgForm)) {
      let modalShow = null;
      if (isEqual(organization, orgForm)) {
        modalShow = false;
      } else {
        modalShow = true;
      }
      await this.setState({
        modalShow,
      });
      this.props.isEditToggle(this.state.modalShow);
    }
  }

  leaveThePage() {
    this.setState((prevState) => ({
      modalShow: !prevState.modalShow,
    }));
  }

  toggle() {
    this.setState((prevState) => ({
      modalShow: !prevState.modalShow,
    }));
  }

  render() {
    const { isChecked } = this.state;
    const {
      account = false,
      organization: { organization },
      t,
    } = this.props;

    let defaultValue = organization;
    // check if stateId set to default 0 by individual account and make it null
    if (organization.stateId === 0) defaultValue.stateId = null;
    if (
      organization.postalStreetAddress ||
      organization.postalCitySuburb ||
      organization.postalStateId ||
      organization.postalPostcode
    ) {
      defaultValue.diffPostalAddress = ['diffPostalAddress'];
    }

    const sectorTypes = this.props.industrySectorTypes.map((item, key) => {
      return {
        key,
        text: item.name,
        value: item.id,
        rest: {
          key: item.id,
        },
      };
    });

    const renderCountries = () => {
      const currentLanguage = this.props.i18n.language || 'en';
      const countryObj = countries.getNames(currentLanguage, {
        select: 'alias',
      });

      return Object.entries(countryObj).map(([code, name]) => ({
        key: code,
        text: name,
        value: code,
      }));
    };

    return (
      <div>
        {/* <NavigationPrompt when={() => this.state.modalShow}> */}
        {({ onConfirm, onCancel }) => (
          <div className="msg-leave">
            <Modal
              onOpen={() => this.toggle()}
              size="tiny"
              open={true}
              closeIcon={
                <Icon onClick={onCancel} name="close" className="closeicon" />
              }
            >
              <Modal.Header className="warning-header-text">
                {t('organisation.profile.leave_modal_title')}
              </Modal.Header>
              <Modal.Content className="warning-content-text">
                {t('organisation.profile.leave_modal_content')}
              </Modal.Content>
              <div className="buttons-stay-leave">
                <Button onClick={onCancel} className="stay">
                  {t('actions.stay')}
                </Button>
                <Button
                  onClick={onConfirm}
                  content={t('actions.leave')}
                  className="leave"
                />
              </div>
            </Modal>
          </div>
        )}
        {/* </NavigationPrompt> */}

        <Segment
          className="content-segment"
          loading={this.props.organizationLoading}
        >
          <Formik
            enableReinitialize
            initialValues={getOrgProfileInitialValues(organization)}
            onSubmit={(values, { resetForm }) => {
              this.onSubmit(values);
              resetForm({ values: '' });
            }}
            validationSchema={
              isChecked
                ? profileValidationSchemaWithDifferentPostalAddress(t)
                : profileValidationSchema(t)
            }
          >
            {({ handleSubmit, isSubmitting, values, setFieldValue }) => {
              // Filter state list based on selected country
              const getFilteredStateList = (selectedCountry) => {
                return this.props.provincesAndStates
                  .filter(
                    (item) =>
                      item.country === selectedCountry || item.country === null
                  )
                  .map((item, key) => ({
                    key,
                    text: item.name,
                    value: item.id,
                    rest: { key: item.id },
                  }));
              };

              const stateList = getFilteredStateList(values.country);

              // Handle country change and reset state values
              const handleCountryChange = (countryValue) => {
                this.onChange('country', countryValue);
                setFieldValue('stateId', null);
                setFieldValue('postalStateId', null);
              };

              return (
                <Form onSubmit={handleSubmit}>
                  <Grid columns={2} stackable>
                    <Grid.Row className="org-row">
                      <Grid.Column
                        mobile={16}
                        tablet={6}
                        computer={6}
                        className="org-sub-column"
                      >
                        <CustomInput
                          id="name"
                          name="name"
                          labelText={`${account ? t('common.account') : t('common.organisation')} ${t('common.name')}`}
                          getValue={(e) => this.onChange('name', e)}
                          requiredStar
                        />

                        <CustomDropdown
                          id="industrySectorTypeId"
                          name="industrySectorTypeId"
                          labelText={t('formulary.organisation_sector_type')}
                          options={sectorTypes}
                          getValue={(e) =>
                            this.onChange('industrySectorTypeId', e)
                          }
                          requiredStar
                        />

                        <CustomInput
                          id="phone"
                          name="phone"
                          labelText={t('formulary.phone')}
                          getValue={(e) => this.onChange('phone', e)}
                          requiredStar
                        />

                        <CustomInput
                          id="domain"
                          name="domain"
                          labelText={t('formulary.web_domain')}
                          getValue={(e) => this.onChange('domain', e)}
                          requiredStar
                        />

                        <CustomInput
                          id="email"
                          name="email"
                          labelText={t('formulary.contact_email')}
                          getValue={(e) => this.onChange('email', e)}
                          requiredStar
                        />

                        <label className="org-profile-pic-label">
                          {t('formulary.organisation_logo')}
                        </label>

                        <div className="org-profile-pic-segment">
                          {/* <div className="org-profile-pic"> */}
                          <Grid.Row>
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                              <span className="org-profile-container">
                                <Image
                                  src={this.state.imgPreView}
                                  size="small"
                                />
                              </span>
                            </Grid.Column>

                            <Grid.Column
                              mobile={16}
                              tablet={16}
                              computer={8}
                              className="org-profile-btn-col"
                            >
                              <div className="org-profile-btn">
                                <label
                                  className="org-click-to-upload"
                                  onClick={() =>
                                    this.fileInputRef.current.click()
                                  }
                                >
                                  {t('formulary.click_to_upload')}
                                </label>

                                {!!this.state.file ? (
                                  <div className="org-profile-pic-name">
                                    <Icon name="attach" />{' '}
                                    {this.state.file.name}
                                  </div>
                                ) : null}
                                <label className="org-profile-des">
                                  {t('formulary.supports_formats')}
                                </label>
                              </div>
                              <input
                                ref={this.fileInputRef}
                                type="file"
                                hidden
                                onChange={(e) => this.onChange('logo', e)}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          {/* </div> */}
                        </div>

                        {isMobile ? null : (
                          <Button
                            disabled={isSubmitting}
                            loading={isSubmitting}
                            type="submit"
                            className="Primary-Button"
                          >
                            {t('actions.save_changes')}
                          </Button>
                        )}
                      </Grid.Column>
                      <Grid.Column
                        mobile={16}
                        tablet={6}
                        computer={6}
                        className="org-sub-column sub-columnRight"
                      >
                        <CustomDropdown
                          search
                          name="country"
                          id="country"
                          labelText={t('formulary.country')}
                          placeholder={t(
                            'formulary.placeholder.select_country'
                          )}
                          options={renderCountries()}
                          getValue={(e) => handleCountryChange(e)}
                          requiredStar
                        />

                        <CustomInput
                          id="streetAddress"
                          name="streetAddress"
                          labelText={t('formulary.address_line_1')}
                          getValue={(e) => this.onChange('streetAddress', e)}
                          requiredStar
                        />
                        <CustomInput
                          id="streetAddress2"
                          name="streetAddress2"
                          labelText={t('formulary.address_line_2')}
                          getValue={(e) => this.onChange('streetAddress2', e)}
                        />
                        <CustomInput
                          id="citySuburb"
                          name="citySuburb"
                          labelText={t('formulary.suburb')}
                          getValue={(e) => this.onChange('citySuburb', e)}
                          requiredStar
                        />

                        <CustomDropdown
                          id="stateId"
                          name="stateId"
                          labelText={t('formulary.postal_state')}
                          options={stateList}
                          getValue={(e) => this.onChange('stateId', e)}
                          requiredStar
                        />
                        <CustomInput
                          id="postcode"
                          name="postcode"
                          labelText={t('formulary.postcode')}
                          getValue={(e) => this.onChange('postcode', e)}
                          requiredStar
                        />

                        {isMobile ? (
                          <Button
                            disabled={isSubmitting}
                            loading={isSubmitting}
                            type="submit"
                            className="Primary-Button"
                          >
                            {t('actions.save_changes')}
                          </Button>
                        ) : null}
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </Segment>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization,
    organizationLoading: state.organization.loading,
    provincesAndStates: state.extra.provincesAndStates,
    industrySectorTypes: state.extra.industrySectorTypes,
    helpTips: state.extra.activityHelpTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOrganization,
      getProvincesAndStates,
      getIndustrySectorTypes,
      updateOrganizationLogo,
      updateOrganizationInfo,
    },
    dispatch
  );
};

OrganizationProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationProfile);

OrganizationProfile = withTranslation()(OrganizationProfile);

export { OrganizationProfile };
